import { supabase } from '../supabaseClient'

// Normalizes a row from get_stones_with_coordinates() (or the deceased-join
// shape some callers already have on hand) into the one shape StoneMap
// consumes: { stone_id, lat, lng, name, deathDate, photoUrl, gps_accuracy_m, condition }
function normalizeStoneRow(row) {
  const deceased = row.stone_deceased?.[0]?.deceased
  const photo = row.stone_photos?.find(p => p.is_primary) || row.stone_photos?.[0]
  return {
    stone_id: row.stone_id,
    lat: row.lat ?? row.latitude ?? null,
    lng: row.lng ?? row.longitude ?? null,
    name: row.name || (deceased
      ? [deceased.first_name, deceased.middle_name, deceased.last_name].filter(Boolean).join(' ')
      : null),
    deathDate: row.date_of_death_verbatim || deceased?.date_of_death_verbatim || null,
    photoUrl: photo?.photo_url || null,
    gps_accuracy_m: row.gps_accuracy_m ?? null,
    condition: row.stone_condition ?? null,
  }
}

// Every stone with a GPS fix, normalized for map display. `filters` is an
// extension point for future filtered views (Patriots, family, condition
// severity, etc.) — not yet implemented server-side; today it fetches
// everything and callers filter client-side if needed. See "Shared Core,
// Many Views" in docs/architecture/decisions.md.
export async function fetchStonesForMap(filters = {}) {
  const { data, error } = await supabase.rpc('get_stones_with_coordinates')
  if (error) return { data: [], error }
  const stones = (data || [])
    .map(normalizeStoneRow)
    .filter(s => s.lat != null && s.lng != null)
  return { data: stones, error: null }
}

// Coordinates for a single stone by id, for callers that already have a
// stone's other fields from a different query and just need lat/lng.
export async function fetchStoneCoords(stoneId) {
  const { data, error } = await fetchStonesForMap()
  if (error) return null
  return data.find(s => s.stone_id === stoneId) || null
}
